import React from "react";
import {css} from "@emotion/react";

import {flexAbsoluteCenter, flexAlignCenter, mb} from "@pg-design/helpers-css-strings";
import {Loader} from "@pg-design/loader-module";
import {getThemeBreakpoint} from "@pg-design/styles-strings";

import {useGetOfferDetailListQuery} from "../../../offer/api/get_offer_detail_list";
import {offerRedirectTracking} from "../../tracking/offer_redirect_tracking";
import {ISearchedRegion} from "../../types/ISearchedRegion";
import {getRankingItems} from "../../utils/get_ranking_items";
import {AwardedOffersBox} from "./winning_offers_list/AwardedOfferBox";
import {WinningOffersBox} from "./winning_offers_list/WinningOfferBox";

interface IProps {
    currentRegion: ISearchedRegion;
    year: string;
}

const WINNERS_COUNT = 3;

export function ArchiveRankingList(props: IProps) {
    const {currentRegion} = props;
    const rankingItems = currentRegion ? getRankingItems(currentRegion.id, props.year) : null;
    const offerIds = rankingItems ? rankingItems.map((item) => item.offerId) : [];
    const {data: rankingOffers} = useGetOfferDetailListQuery({offerIds});

    return (
        <div css={archiveOffersList}>
            {rankingItems && rankingOffers && rankingOffers.length > 0 ? (
                rankingItems.map((item) => {
                    const offer = rankingOffers.find((offer) => offer.id === item.offerId);

                    if (offer) {
                        const onOfferTracking = () => {
                            offerRedirectTracking({
                                city: currentRegion.name,
                                position: item.regionOrder,
                                vendor: offer.vendor.name,
                                offerName: offer.name
                            });
                        };

                        return item.regionOrder <= WINNERS_COUNT ? (
                            <WinningOffersBox offer={offer} position={item.regionOrder} key={offer.id} onClick={onOfferTracking} />
                        ) : (
                            <AwardedOffersBox offer={offer} key={offer.id} onClick={onOfferTracking} />
                        );
                    }

                    return null;
                })
            ) : (
                <div css={flexAbsoluteCenter}>
                    <Loader />
                </div>
            )}
        </div>
    );
}

const archiveOffersList = css`
    ${mb(6)};
    ${flexAlignCenter};
    flex-direction: column;

    @media (min-width: ${getThemeBreakpoint().sm}) {
        margin-bottom: 8.8rem;
    }
`;
import React from "react";
import {css} from "@emotion/react";

import {flexAbsoluteCenter, flexAlignCenter, mb} from "@pg-design/helpers-css-strings";
import {Loader} from "@pg-design/loader-module";
import {getThemeBreakpoint} from "@pg-design/styles-strings";

import {useGetOfferDetailListQuery} from "../../../offer/api/get_offer_detail_list";
import {offerRedirectTracking} from "../../tracking/offer_redirect_tracking";
import {ISearchedRegion} from "../../types/ISearchedRegion";
import {getRankingItems} from "../../utils/get_ranking_items";
import {AwardedOffersBox} from "./winning_offers_list/AwardedOfferBox";
import {WinningOffersBox} from "./winning_offers_list/WinningOfferBox";

interface IProps {
    currentRegion: ISearchedRegion;
    year: string;
}

const WINNERS_COUNT = 3;

export function ArchiveRankingList(props: IProps) {
    const {currentRegion} = props;
    const rankingItems = currentRegion ? getRankingItems(currentRegion.id, props.year) : null;
    const offerIds = rankingItems ? rankingItems.map((item) => item.offerId) : [];
    const {data: rankingOffers} = useGetOfferDetailListQuery({offerIds});

    return (
        <div css={archiveOffersList}>
            {rankingItems && rankingOffers && rankingOffers.length > 0 ? (
                rankingItems.map((item) => {
                    const offer = rankingOffers.find((offer) => offer.id === item.offerId);

                    if (offer) {
                        const onOfferTracking = () => {
                            offerRedirectTracking({
                                city: currentRegion.name,
                                position: item.regionOrder,
                                vendor: offer.vendor.name,
                                offerName: offer.name
                            });
                        };

                        return item.regionOrder <= WINNERS_COUNT ? (
                            <WinningOffersBox offer={offer} position={item.regionOrder} key={offer.id} onClick={onOfferTracking} />
                        ) : (
                            <AwardedOffersBox offer={offer} key={offer.id} onClick={onOfferTracking} />
                        );
                    }

                    return null;
                })
            ) : (
                <div css={flexAbsoluteCenter}>
                    <Loader />
                </div>
            )}
        </div>
    );
}

const archiveOffersList = css`
    ${mb(6)};
    ${flexAlignCenter};
    flex-direction: column;

    @media (min-width: ${getThemeBreakpoint().sm}) {
        margin-bottom: 8.8rem;
    }
`;
